module.exports = __webpack_public_path__ + "img/mapfre-logo.c27b2664.svg";